__turbopack_context__.v({
  "className": "caveat_8a5f83d7-module__qFCYaW__className",
});
